import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $trimTextContentFromAnchor } from '@lexical/selection';
import { $getSelection, $isRangeSelection, EditorState } from 'lexical';

export function MyOnChangePlugin({
  onChange,
  maxLength,
}: {
  onChange?: (editorState: EditorState) => void;
  maxLength?: number;
}) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (!onChange) return;
    return editor.registerUpdateListener(({ editorState }) => {
      onChange(editorState);
    });
  }, [editor, onChange]);
  useEffect(() => {
    return editor.registerTextContentListener((textContent) => {
      if (!maxLength) return;
      if (textContent.length > maxLength) {
        editor.update(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            const anchor = selection.anchor;
            $trimTextContentFromAnchor(editor, anchor, textContent.length - maxLength);
          }
        });
      }
    });
  }, [editor, maxLength]);
  return null;
}
